module.exports = __webpack_public_path__ + "static/media/calendarAdd.886ca1c3.svg";